import React from "react";
import { Pitch } from "@services/Pitches.service";
import { formatNumberToUSD } from "@features/utils/functions";
import moment from "moment";
import { MobileExpandedRow } from "@apps/MarketsApp/components/MobileExpandedRow";
import { formatTimeRemaining } from "../utils/formatTimeRemaining";

type Props = {
  pitch: Pitch;
};

export const PitchMobileExpandedRow = ({ pitch }: Props) => {
  const rows = [
    {
      label: "TIME REMAINING",
      content:
        pitch.time_remaining && pitch.time_remaining > 0
          ? formatTimeRemaining(pitch.time_remaining)
          : "Finished",
    },
    {
      label: "TYPE",
      content: pitch.specialisation_type || "-",
    },
    {
      label: "PITCH DATE",
      content: pitch.pitch_date
        ? moment(pitch.pitch_date).format("MMM DD, yyyy")
        : "-",
    },
    {
      label: "NO. OF INVESTORS",
      content: pitch.number_of_investors ?? "-",
    },
    {
      label: "RAISED %",
      content: `${Number(pitch.raised_percent ?? 0).toFixed(0)}%`,
    },
    {
      label: "RAISED $",
      content: `${formatNumberToUSD(
        Number(pitch.raised_amount ?? 0)
      )} of ${formatNumberToUSD(Number(pitch.expected_amount ?? 0))}`,
    },
  ];

  return <MobileExpandedRow rows={rows} />;
};
